import React from 'react';
import { Carousel, Image } from 'react-bootstrap';
import { Link, NavLink, useHistory } from 'react-router-dom';
import Countdown, { zeroPad } from 'react-countdown';
import {
  CAPTAIN_ROUTE,
  TREEHOUSE_ROUTE,
} from '../../../constants/routes.constants';
import { getSpecialCountTime } from '../../../utils/camp.utils';
import verified from '../../../assets/icon/Verified-badge.svg';
import goldTick from '../../../assets/icon/gold_tick.svg';
import silverTick from '../../../assets/icon/silver_tick.svg';
import ZoomButtonSpecialCamp from './ZoomButtonSpecialCamp';
import defaultProfile from '../../../assets/profile/default-profile-guardian.svg';

const MultiCampSlider = ({ specialCamp, key }) => {
  const history = useHistory();
  const getSpecialCampSchedule = () => {
    const convertedTime = getSpecialCountTime(
      specialCamp?.end_date_time,
      specialCamp?.timezone
    );
    return convertedTime;
  };

  const countdownRenderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return (
        <div className="join-button px-3">
          <ZoomButtonSpecialCamp
            title="Join Camp"
            link={specialCamp?.zoom_link}
          />
        </div>
      );
    } else {
      return (
        <h5 className="f-600">
          <div className="countdown">
            <div className="counts-days">
              <span id="days">{days}</span>
              <br />
              <span>Days</span>
            </div>
            <div className="counts-days">
              <span id="hrs">{zeroPad(hours)}</span>
              <br />
              <span>hrs</span>
            </div>
            <div className="counts-days">
              <span id="mins">{zeroPad(minutes)}</span>
              <br />
              <span>mins</span>
            </div>
            <div className="counts-days">
              <span id="secs">{zeroPad(seconds)}</span>
              <br />
              <span>secs</span>
            </div>
          </div>
        </h5>
      );
    }
  };

  const handleSpecialCampClick = () => {
    if (specialCamp?.challenge?.treehouse_user?.id) {
      let id = specialCamp.challenge.treehouse_user.slug
        ? specialCamp.challenge.treehouse_user?.slug
        : specialCamp.challenge.treehouse_user?.id;
      history.push({
        pathname: `${TREEHOUSE_ROUTE}/${id}`,
        state: {
          type: specialCamp.challenge.treehouse_user?.slug ? 'slug' : 'id',
        },
      });
    }
  };

  return (
    <React.Fragment>
      <div className="camp-schedule-title p-3">{'Upcoming Camp'}</div>
      <div className="inner-camp-box-my-room width-box height-box">
        <div className="width-box height-box camp-captain-profile-box">
          <ul
            className="d-flex kid-up-box "
            role="button"
            //   onClick={handleCampClick}
          >
            <li className="kid-up-name">
              <div className="camp-captain-profile-box-img">
                <Image
                  src={
                    specialCamp?.challenge?.treehouse_user?.picture
                      ? specialCamp.challenge.treehouse_user.picture
                      : specialCamp?.picture_url
                      ? specialCamp?.picture_url
                      : specialCamp?.created_by?.picture_url
                      ? specialCamp?.created_by?.picture_url
                      : defaultProfile
                  }
                  alt=""
                  className="camp_img"
                  width="50"
                />
                {specialCamp?.challenge?.treehouse_user
                  ?.type_of_organisation === 'non profit' ? (
                  <Image src={silverTick} alt="" className="green-tick" />
                ) : specialCamp?.challenge?.treehouse_user
                    ?.type_of_organisation === 'profit' ? (
                  <Image src={goldTick} alt="" className="green-tick" />
                ) : (
                  <Image
                    src={verified}
                    alt=""
                    className="green-tick"
                    style={{ top: '-7px' }}
                  />
                )}
              </div>
              {specialCamp?.name}
            </li>
          </ul>
          <p onClick={handleSpecialCampClick}>
            Meet the expert:&nbsp;
            <NavLink to="#">
              {specialCamp?.challenge ? (
                <a href="javascript:void(0);">
                  {specialCamp?.challenge
                    ? specialCamp?.challenge?.treehouse_user?.name
                    : specialCamp?.created_by?.first_name +
                      specialCamp?.created_by?.last_name}
                </a>
              ) : (
                specialCamp?.created_by?.first_name +
                ' ' +
                specialCamp?.created_by?.last_name
              )}
            </NavLink>
          </p>
          <Countdown
            date={Date.now() + Number(getSpecialCampSchedule())}
            renderer={countdownRenderer}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default MultiCampSlider;
